<template>
  <component :is="mode" :lang="lang"></component>
</template>

<script>
const TheFooter = () => import('./the-footer.vue');
const TheFooterTW = () => import('./the-footer-tw.vue');
export default {
  components: {
    TheFooter,
    TheFooterTW
  },
  props: {
    lang: {
      type: String,
      default: () => "en"
    },
  },
  data() {
    return {
      mode: ''
    };
  },
  watch: {
    lang: {
      handler: function(newVal, oldVal) {
        if(newVal) {
          this.mode = this.lang == 'tw' ? 'TheFooterTW' : 'TheFooter'
        }
      },
      immediate: true
    }
  }
};
</script>

<style lang="scss" scoped>
@function vwPc($px, $ratio: 2) {
  $baseWidth: 3840px;

  @if $ratio ==1 {
      $baseWidth: 1920px;
  }

  @return ($px/$baseWidth) * 100vw
};

@function vwApp($px) {
    @return ($px/750px) * 100vw
};

.footer {
  position: relative;
  z-index: 1;
  width: 100%;
  height: vwPc(160px);
  background-color: #252525;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 vwPc(40px);

  .footer-media {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate3d(-50%, -50%, 0);
  }

  .xd-footer-logos {
    height: 28px;
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    .xd-footer-xdlogo {
      display: inline-block;
      width: 100px;
      height: 100%;
      background-image: url("https://website.xdcdn.net/homepage/torchlight/imgs/overseas/logo.svg");
      background-position: center;
      background-repeat: no-repeat;
      background-size: contain;
    }
    .text {
      font-size: vwPc(28px);
      margin-top: vwPc(6px);
      margin-left: vwPc(20px);
    }
  }
  .footer-link {
    font-size: vwPc(28px);
    color: #fff;
    letter-spacing: 0;
    white-space: nowrap;
    a {
      color: #fff;
    }
  }
}

@media screen and (max-width: 750px) {
  .footer {
    height: vwApp(190px);
    padding: 0 vwApp(40px);
    display: block;
    overflow: hidden;

    .footer-media {
      position: absolute;
      top: 13%;
      // left: 50%;
      transform: translate3d(-50%, 0, 0);
    }

    .xd-footer-logos {
      height: vwApp(30px);
      margin: vwApp(105px) auto vwApp(10px);
      .xd-footer-xdlogo {
        width: vwApp(110px);
      }
      .text {
        font-size: vwApp(16px);
        margin-top: vwApp(3px);
        margin-left: vwApp(10px);
      }
    }
    .footer-link {
      font-size: vwApp(16px);
      text-align: center;
    }
  }
}
</style>